

import { tryResolve } from "stores/diContext";
export class HttpFactory {
    constructor(private baseUrl) { }
    url(api) {
        return new HttpRequestBuilder(this.baseUrl, api);
    }
}
/**
 * 全局配置
 */
export const globalOptions = {

}

let _setup_language = false;
function getLanguage($?: JQueryStatic) {
    //var app = tryResolve("app");
    //if (app && app.language) {
    //    return app.language || "en-US";
    //}
    //return "en-US";
    if (_setup_language) {
        return;
    }
    _setup_language = true;
    if ($) {
        $.ajaxPrefilter((options, originalOptions, jqXHR) => {
            options.headers = options.headers || {}; // 清空自定义的请求头
            var app = tryResolve("app");
            if (app && app.language) {
                options.headers['Accept-Language'] = app.language || "en-US";
            }
        });

        if ($.support.cors || !$.ajaxTransport || !window['XDomainRequest']) {
            //system.log("use default ajax");
        }
        else {
            //IE9 跨域支持
            var httpRegEx = /^(https?:)?\/\//i;
            var getOrPostRegEx = /^get|post$/i;
            var sameSchemeRegEx = new RegExp('^(\/\/|' + location.protocol + ')', 'i');
            $.ajaxTransport('* text html xml json', function (options, userOptions:any, jqXHR) {
                // Only continue if the request is: asynchronous, uses GET or POST method, has HTTP or HTTPS protocol, and has the same scheme as the calling page
                if (!options.crossDomain || !options.async || !getOrPostRegEx.test(options.type) || !httpRegEx.test(options.url) || !sameSchemeRegEx.test(options.url)) {
                    return;
                }

                var xdr = null;

                return {
                    send: function (headers, complete) {
                        var postData = '';
                        var userType = (userOptions.dataType || '').toLowerCase();

                        xdr = new window['XDomainRequest']();
                        if (/^\d+$/.test(`${userOptions.timeout}`)) {
                            xdr.timeout = userOptions.timeout;
                        }

                        xdr.ontimeout = function () {
                            complete(500, 'timeout');
                        };

                        xdr.onload = function () {
                            var allResponseHeaders = 'Content-Length: ' + xdr.responseText.length + '\r\nContent-Type: ' + xdr.contentType;
                            var status: any = {
                                code: 200,
                                message: 'success'
                            };
                            var responses: any = {
                                text: xdr.responseText
                            };
                            try {
                                if (userType === 'html' || /text\/html/i.test(xdr.contentType)) {
                                    responses.html = xdr.responseText;
                                } else if (userType === 'json' || (userType !== 'text' && /\/json/i.test(xdr.contentType))) {
                                    try {
                                        responses.json = $.parseJSON(xdr.responseText);
                                    } catch (e) {
                                        status.code = 500;
                                        status.message = 'parseerror';
                                        //throw 'Invalid JSON: ' + xdr.responseText;
                                    }
                                } else if (userType === 'xml' || (userType !== 'text' && /\/xml/i.test(xdr.contentType))) {
                                    var doc = new ActiveXObject('Microsoft.XMLDOM');
                                    doc.async = false;
                                    try {
                                        doc.loadXML(xdr.responseText);
                                    } catch (e) {
                                        doc = undefined;
                                    }
                                    if (!doc || !doc.documentElement || doc.getElementsByTagName('parsererror').length) {
                                        status.code = 500;
                                        status.message = 'parseerror';
                                        throw 'Invalid XML: ' + xdr.responseText;
                                    }
                                    responses.xml = doc;
                                }
                            } catch (parseMessage) {
                                throw parseMessage;
                            } finally {
                                complete(status.code, status.message, responses, allResponseHeaders);
                            }
                        };

                        // set an empty handler for 'onprogress' so requests don't get aborted
                        xdr.onprogress = function () { };
                        xdr.onerror = function () {
                            complete(500, 'error', {
                                text: xdr.responseText
                            });
                        };

                        if (userOptions.data) {
                            postData = ($.type(userOptions.data) === 'string') ? userOptions.data : $.param(userOptions.data);
                        }
                        xdr.open(options.type, options.url);
                        xdr.send(postData);
                    },
                    abort: function () {
                        if (xdr) {
                            xdr.abort();
                        }
                    }
                };
            });
        }

    }
}


export class HttpRequestBuilder {
    get $(): JQueryStatic {
        return tryResolve("$") || window['jQuery'];
    }
    constructor(public baseUrl, api: string) {
        var lang = getLanguage(this.$);
        if (lang) {
            var linkChar = "?";
            if (api.indexOf("?") > -1) {
                linkChar = "&";
            }
            this.api = `${api}${linkChar}culture=${lang}&ui-culture=${lang}`;
        } else {
            this.api = `${api}`;
        }
        this.options.url = `${this.baseUrl}${this.api}`;
    }
    api;
    callbackParam = "callback";
    url: string;
    xhr: JQueryXHR;
    options: JQueryAjaxSettings = {
        dataType: 'json',
    };

    /**
     * 设置ajax配置
     * @param key 配置名
     * @param options 设置
     * @param replace 是否替换原值
     */
    set(key, options, replace = true) {
        if (replace) {
            this.options[key] = options;
        }
        else {
            this.options[key] =this.$.extend(null, this.options[key], options);
        }
        return this;
    }

    /**
     * 发起ajax请求
     * @param options
     */
    private async httpRequest(options) {
        options = this.settings(options);
        this.xhr = this.$.ajax(options);
        var response = await this.xhr;
        if (response.success) {
            return response.result;
        }
        throw response;
    }

    /**
     * 获取ajax设置
     * @param options
     */
    private settings(options: JQueryAjaxSettings) {
        if (options.type != "GET") {
            options.contentType = "application/json";
        }
        return { ...globalOptions, ...this.options, ...options }
    }

    /**
     * GET 请求
     * @param query,查询条件
     */
    get(query?) {
        return this.httpRequest({ type: "GET", data: query });
    }

    /**
     * POST 请求
     * @param data
     */
    post(data?) {
        return this.httpRequest({
            type: "POST",
            data: JSON.stringify(data)
        });
    }

    /**
     * PUT 请求
     * @param data
     */
    put(data) {
        return this.httpRequest({
            type: "PUT",
            data: JSON.stringify(data)
        });
    }

    /**
     * DELETE 请求
     */
    remove(query) {
        return this.httpRequest({ type: "DELETE", data: query });
    }

    /**
     * jsonp 请求
     * @param query 查询字符串
     * @param callbackParam 回调函数名
     */
    jsonp(query, callbackParam?) {
        if (this.url.indexOf('=?') == -1) {
            callbackParam = callbackParam || this.callbackParam;
            if (this.url.indexOf('?') == -1) {
                this.url += '?';
            } else {
                this.url += '&';
            }

            this.url += callbackParam + '=?';
        }
        return this.httpRequest({ url: this.url, dataType: "jsonp", data: query });
    }

    /**
     * 停止ajax请求
     */
    stop() {
        this.xhr.abort();
    }
}

if (__DEV__) {
    window['http'] = HttpFactory;
}
export default HttpFactory;



// WEBPACK FOOTER //
// ./src/utils/http.ts